const FEW_RATINGS_THRESHOLD = 15

export function formatRatingsCount(
  count: number,
  { compact = false }: { compact?: boolean } = {}
): string {
  if (count < FEW_RATINGS_THRESHOLD) return 'few reviews'
  return compact ? `${count}` : `${count} reviews`
}
